import { render } from "./SearchComponent.vue?vue&type=template&id=f623fb78&ts=true"
import script from "./SearchComponent.vue?vue&type=script&lang=ts"
export * from "./SearchComponent.vue?vue&type=script&lang=ts"

import "./SearchComponent.vue?vue&type=style&index=0&id=f623fb78&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__